module.exports = __webpack_public_path__ + "img/man.3228efe5.png";